import React, { ReactElement, useCallback, useState } from 'react';
import ModalStateEnum from '~UI/ModalStateEnum';

import TitleSearchModal from './TitleSearchModal';
import { AiOutlineFileSearch } from 'react-icons/ai';

export default function TitleSearch(props: {
    applicationPropertyUuid: string
}): ReactElement {
    const { applicationPropertyUuid } = props;

    const [isModalOpen, setIsModalOpen] = useState<ModalStateEnum>(ModalStateEnum.Off);

    const onOpenModal: () => void = useCallback(() => {
        setIsModalOpen(ModalStateEnum.Open);
    }, []);

    const onCloseModal: () => void = useCallback(() => {
        setIsModalOpen(ModalStateEnum.Closed);
    }, []);

    const modalBlock: JSX.Element = ModalStateEnum.Off !== isModalOpen && (
        <TitleSearchModal
            applicationPropertyUuid={applicationPropertyUuid}
            isOpen={ModalStateEnum.Open === isModalOpen}
            onCancel={onCloseModal}
        />
    );

    return (
        <>
            <a onClick={onOpenModal}>
                <AiOutlineFileSearch />
            </a>
            {modalBlock}
        </>
    );
}
